import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import { act } from "react-dom/test-utils";
import Cookies from "js-cookie";
import config from "../config";

class VehicleFuelCalibrationStore {
  vehicleFuelCalibrationVehicles = [];
  vehicleCalibrationGridEdit = [];
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicleFuelCalibrationVehicles: observable,
      vehicleCalibrationGridEdit: observable,

      loading: observable,
      loadData: action,
      addData: action,
      getFuelDetails: action,
      deleteRecord: action,
      getGridDetails: action,
      deleteGridData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, currentPage }) {
    this.loading = true;
    var queryParams = { offset: offset, limit: limit, page: currentPage };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/fuelCalibration/getFuelCalibrationDetails", {
        params: queryParams,
      });
    this.vehicleFuelCalibrationVehicles = response?.data?.data;
    this.loading = false;
  }

  async addData(vehiclefuel) {
    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/fuelCalibration/createOrUpdateFuelCalibration",
        vehiclefuel
      );
    return response;
  }

  async deleteRecord({ Id }) {
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/fuelCalibration/deleteFuelCalibration/${Id}`);
    return response;
  }

  async getFuelDetails(Id) {
    var queryParams = { Id: Id };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/fuelCalibration/getFuelCalibrationDetails", {
        params: queryParams,
      });
    return response.data.data[0];
  }

  async deleteGridData({ Id, fuelCalibrationId }) {
    var response = await postApi
      .getClient("")
      .delete(
        config.NodeUrl +
          `/fuelCalibration/deleteGridData/${Id}/${fuelCalibrationId}`
      );
    return response;
  }

  async getGridDetails(Id) {
    var postData = { Id: Id };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/fuelCalibration/getGridData", {
        params: postData,
      });
    this.vehicleCalibrationGridEdit = response.data.data;
    return response.data.data;
  }
}

export default VehicleFuelCalibrationStore;
